import { globalModule } from '../../../global/global.module';
import { AppEvent, AppEventType } from '../AppEventType';

/**
 * This file contains a Transition Hook which protects a
 * route that requires authentication.
 *
 * This hook redirects to /login when both:
 * - The user is not authenticated
 * - The user is navigating to a state that requires authentication
 */

// special injection arrangements because of the ui-router
onSuccessHookRunBlock.$inject = ['$transitions', '$window','EventQueueService'];

function onSuccessHookRunBlock($transitions, $window, eventQueue ) {
   $transitions.onSuccess({}, function (transition) {
      const transitionFrom = transition.from().name;
      const transitionTo = transition.to().name;

      // An event is dispatched from here so that the menu
      // module can catch and act on it to synchronise 
      // the menu display ?
      // https://medium.com/@Armandotrue/broadcasting-events-in-angular-b85289a4d685
      eventQueue.dispatch(new AppEvent(AppEventType.TransitionSuccess, {
         from: transitionFrom,
         to: transitionTo
      }));
   });
}

globalModule.run(onSuccessHookRunBlock);
